export default function NewsletterRibbon() {
  return (
    <section className="newsletter-ribbon">
      <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-4 p-4">
        <div>
          <div className="small fw-bold text-uppercase mb-1">
            EAC2027 Newsletter
          </div>

          <h2 className="h3 mb-1">
            Stay connected with the aerosol community
          </h2>

          <p className="mb-0">
            Get the latest EAC2027 updates before, during, and beyond the conference.
          </p>
        </div>

        <a
          href="https://756b0975.sibforms.com/serve/MUIFAF4fmYERcexYY_uDEXM3K7zbhtN8qyTJpdA_6TpSOUsVG1EbFMaeiJ8WpmRFGexTNw2pQZesqXobGbcTMc3l-Mc9qA1AhwRKCxU4qUkiplhpdirGlWTsxfbysVwNcDIeu4hYB0TThFZMxrhLQJLBAC5B5ZE0hUNEqzvxxZCvZBcoGZiDtIB4_aG6_6xE5CEhIZIj9MiYNbFi"
          target="_blank"
          rel="noreferrer"
          className="btn newsletter-ribbon-btn flex-shrink-0"
        >
          <i className="bi bi-envelope-paper me-2" aria-hidden="true"></i>
          Subscribe to newsletter
        </a>
      </div>
    </section>
  );
}